import PreviewSvg from "./PreviewSvg";
import CommentsSvg from "./CommentsSvg";
import DownloadSvg from "./DownloadSvg";
import UnreadSvg from "./UnreadSvg";
import AdmissionForwardSvg from "./AdmissionForwardSvg";
import TasksSvg from "./TasksSvg";
import MoveSvg from "./MoveSvg";
import DeleteSvg from "./DeleteSvg";
import SettingsSvg from "./SettingsSvg";
import StarDefaultSvg from "./StarDefaultSvg";
import StarYellowSvg from "./StarYellowSvg";
import StarBlackSvg from "./StarBlackSvg";
import StarGreenSvg from "./StarGreenSvg";
import StarRedSvg from "./StarRedSvg";
import HeadBoomSvg from "./HeadBoomSvg";
import FingersSvg from "./FingersSvg";
import MoneySvg from "./MoneySvg";
import StopSvg from "./StopSvg";
import SosSvg from "./SosSvg";
import ChooseAllSvg from "./ChooseAllSvg";
import ClearAllSvg from "./ClearAllSvg";
import SaveSvg from "./SaveSvg";
import SettingsTabPlusSvg from "./SettingsTabPlusSvg";
import SettingsTabDeleteSvg from "./SettingsTabDeleteSvg";
export const applicationPageSvgConst = {
  PreviewSvg,
  CommentsSvg,
  DownloadSvg,
  UnreadSvg,
  AdmissionForwardSvg,
  TasksSvg,
  MoveSvg,
  DeleteSvg,
  SettingsSvg,
  StarDefaultSvg,
  StarBlackSvg,
  StarYellowSvg,
  StarGreenSvg,
  StarRedSvg,
  HeadBoomSvg,
  FingersSvg,
  MoneySvg,
  StopSvg,
  SosSvg,
  ChooseAllSvg,
  ClearAllSvg,
  SaveSvg,
  SettingsTabPlusSvg,
  SettingsTabDeleteSvg,
};
